const filterTimeOptionShortTitle =  function(value, shortMode = true, typeFilter = 'rentals') {


    const tableTimeOptions = typeFilter === 'events' ? JSON.parse(window.application.eventTableTimeOptions) : JSON.parse(window.application.mixTableTimeOptions)
    const tableTimeOptionsShirtTitle = typeFilter === 'events' ? window.application.eventTableTimeOptionsShirtTitle : window.application.mixTableTimeOptionsShirtTitle
    const tableTimeOptionsTitle = typeFilter === 'events' ? window.application.eventTableTimeOptionsTitle : window.application.mixTableTimeOptionsTitle



    const pos = tableTimeOptions.indexOf(value);

    if(pos !== -1) {
        return shortMode ? tableTimeOptionsShirtTitle[pos] : tableTimeOptionsTitle[pos]
    } else {
        return '?';
    }

    // switch (value) {
    //     case 1:
    //         return shortMode ? '1 hr' : '1 hour';
    //     case 2:
    //         return shortMode ? '2 hr' : '2 hours';
    //     case 3:
    //         return shortMode ? '3 hr' : '3 hours';
    //     case 4:
    //         return shortMode ? '5 hr' : '5 hours';
    //     case 5:
    //         return 'All day';
    //     case 7:
    //         return shortMode ? '24 hrs' : '24 hours';
    //     default:
    //         return '?';
    // }
}

export default filterTimeOptionShortTitle;
